export default "__VITE_ASSET__CiRiH0Pn__"